<template>
  <div v-if="emptyTokenMsg">{{emptyTokenMsg}}</div>
</template>
<script>
import xesBaseFn from '~common/assets/js/xes.base.js'
export default {
  data () {
    return {
      'emptyTokenMsg': ''
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.getMenuInit()
    next()
  },
  methods: {
    /**
     * 获取token的方法
     */
    getMenuInit () {
      // 获取url?后的token字段
      let token = xesBaseFn.parseStr(window.location.href).token || ''
      token = token || xesBaseFn.getCookie('childrenToken', true)
      window.token = token
      // 如果token存在则存入cookie的token键值中,并且不允许跨域设置
      if (token) {
        // xesBaseFn.delCookie('childrenToken',true)
        xesBaseFn.setCookie('token', decodeURIComponent(token))
        // 设置完token后重定向到/路由
        this.$router.push('/')
      } else {
        // 如果token不存在，则显示提示信息
        this.emptyTokenMsg = '未获取到登陆token，请从中台进入系统。'
      }
    }
  },
  mounted () {
    this.getMenuInit()
  }
}
</script>



// WEBPACK FOOTER //
// common/components/Admin/getMenu.vue